const filterValueKeys = ['min', 'max', 'exact', 'percentage', 'variance'] as const;

export const filterHasValue = (filter: unknown): boolean =>
  typeof filter === 'object' &&
  filter !== null &&
  filterValueKeys.some((key) => {
    const value = (filter as Partial<Record<(typeof filterValueKeys)[number], unknown>>)[key];
    return value !== undefined && value !== '';
  });
